/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EdicionAdminController', EdicionAdminController);

    /* @ngInject */
    function EdicionAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                    ModalService, Edicion, JsonUtils, Principal) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });


        vm.item = Edicion;
        //nombre del usuario y rol(para los permisos)
        vm.userName = Principal.identity().$$state.value.login;
        vm.userRole =  Principal.identity().$$state.value.role;


        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        if ($stateParams.relacionId == null) {
            vm.function = "adminSearch";
        }

        vm.filterTabla = {
            key: undefined,
            id: $stateParams.relacionId,
            revisado: undefined,
            publicado: undefined,
            traducido: undefined,
            idResponsable: $stateParams.idResponsable,
            nombreResponsable: $stateParams.nombreResponsable,
            rolResponsable: $stateParams.rolResponsable,
            idLugar: $stateParams.idLugar,
            nombreLugar: $stateParams.nombreLugar

        };

        vm.filter = angular.copy(vm.filterTabla);

        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filterTabla,
            sorting: {titulo: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Edicion.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.edicion.delete.name',
                                body: 'admin.edicion.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
        // Buscar
        vm.buscar = function (pageChange) {
            if (!pageChange) {
                $stateParams.page = 1;
            }
            vm.filterTabla.page = $stateParams.page - 1;
            angular.extend(vm.filterTabla, vm.filter);
        };

        // Limpiar formulario y hacer búsqueda
        vm.clear = function () {
            var filterCopy = angular.copy(vm.filter);
            JsonUtils.cleanJson(vm.filter);
            JsonUtils.cleanJson(vm.filterTabla);
            vm.buscar(false);
        };
    }
})(angular);
